import React from 'react';
import emojione from 'emojione';
import Emoticon from '../emoticons/Emoticon.react';

class Emojify extends React.Component {
		static defaultProps = {
		  unicodeRegexp: new RegExp(`<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(${emojione.unicodeRegexp})`, 'gi'),
		};

		parseString = (str) => {
		  var replaceWith,
		    unicode,
		    alt;

		  const regexp = this.props.unicodeRegexp;
		  let match = regexp.exec(str);

		  const resultElements = [];
		  let prevIndex = 0;
		  let key = 0;

		  if (!emojione.unicodeAlt) {
		    var mappedUnicode = emojione.mapShortToUnicode();
		  }
		  while (match != null) {
		    var unmatched;
		    var emoticon;
		    let matchType = '';

		    if (typeof match[0] !== 'undefined') {
		      if (match[0] in emojione.jsecapeMap) {
		        matchType = 'unicode';
		      }
		    }

		    if ((match[0] === '') || !(matchType == 'unicode')) {
		      resultElements.push(React.createElement('span', { key: key++ }, match[0]));
		    } else {
		      var unicode;
		      unicode = emojione.jsecapeMap[match[0]];

		      var alt = (emojione.unicodeAlt) ? emojione.convert(unicode) : mappedUnicode[unicode];
		      let basePath = '';
		      if (globals.cacheServers && globals.cacheServers.length) {
		        basePath = globals.cacheServers[0];
		      }
		      const src = `${basePath + emojione.imagePathPNG + unicode}.png${emojione.cacheBustParam}`;
		      emoticon = <Emoticon alt={alt} src={src} key={key++} />;
		    }

		    if (typeof match.index !== 'undefined') {
		      unmatched = str.substring(prevIndex, match.index);
		      prevIndex = match.index + match[0].length;
		    } else {
		      unmatched = str;
		    }

		    resultElements.push(React.createElement('span', { key: key++ }, unmatched));
		    resultElements.push(emoticon);

		    match = regexp.exec(str);
		  }

		  resultElements.push(React.createElement('span', { key: key++ }, str.substring(prevIndex, str.length)));

		  return resultElements;
		};

		parse = (children) => {
		  const self = this;
		  let parsed = children;

		  if (typeof children === 'string') {
		    parsed = this.parseString(children);
		  } else if (React.isValidElement(children)) {
		    parsed = React.cloneElement(
		      children,
		      {},
		      this.parse(children.props.children),
		    );
		  } else if (children instanceof Array) {
		    parsed = children.map(child => self.parse(child));
		  }

		  return parsed;
		};

		render() {
		  const parsedChildren = this.parse(this.props.children);

		  return (
  <div>
    {parsedChildren}
  </div>
		  );
		}
}

module.exports = Emojify;
